import React from 'react';
import PropTypes from 'prop-types';
import textProvider from '../texts/textProvider';

const CLASS_NAMES = {
    GRID_NO_ROWS_TEMPLATE_WRAPPER: 'grid-no-rows-template-wrapper',
    GRID_NO_ROWS_TEMPLATE_INNER: 'grid-no-rows-template-inner',
    GRID_NO_ROWS_TEMPLATE_IMAGE: 'grid-no-rows-template-image',
    GRID_NO_ROWS_TEMPLATE_TEXT: 'grid-no-rows-template-text'
};

const CONSTANT_TEXTS = {
    NO_ROWS_MESSAGE: textProvider.getText('gridNoRowsTemplate', 'message')
};

/**
 * Shown when a DataGrid has zero rows. ut-react-common passes this component
 * to react-data-grid v7 as `renderers.noRowsFallback`, which renders it as a
 * direct child of `[role="grid"]` below the header row (not as an overlay).
 */
const GridNoRowsTemplate = ({className, message = CONSTANT_TEXTS.NO_ROWS_MESSAGE}) => (
    <div className={CLASS_NAMES.GRID_NO_ROWS_TEMPLATE_WRAPPER}>
        <div className={CLASS_NAMES.GRID_NO_ROWS_TEMPLATE_INNER}>
            <div className={CLASS_NAMES.GRID_NO_ROWS_TEMPLATE_IMAGE} aria-hidden="true" />
            <div className={className || CLASS_NAMES.GRID_NO_ROWS_TEMPLATE_TEXT}>{message}</div>
        </div>
    </div>
);

GridNoRowsTemplate.propTypes = {
    message: PropTypes.string,
    className: PropTypes.string
};

export default GridNoRowsTemplate;
